#!/usr/bin/env node

import { Command } from 'commander';
import chalk from 'chalk';
import { startDevServer } from './dev.js';
import { buildApp } from './build.js';
import { startSSRServer } from './start.js';
import { createProject } from './create.js';

const program = new Command();

program
    .name('rowiejs')
    .description('Meta-framework React de nueva generación')
    .version('0.4.4');

program
    .command('create <project-name>')
    .description('Crear un nuevo proyecto rowiejs')
    .option('-t, --template <template>', 'Template a usar (basic, blog, ecommerce)', 'basic')
    .option('-d, --directory <dir>', 'Directorio donde crear el proyecto', '.')
    .action(async (projectName, options) => {
        try {
            await createProject({
                projectName,
                template: options.template,
                directory: options.directory
            });
        } catch (error) {
            console.error(chalk.red('❌ Error creando proyecto:'), error);
            process.exit(1);
        }
    });

program
    .command('dev')
    .description('Iniciar servidor de desarrollo')
    .option('-p, --port <port>', 'Puerto del servidor', '3000')
    .option('-h, --host <host>', 'Host del servidor', 'localhost')
    .option('-a, --app-dir <dir>', 'Directorio de la aplicación', 'app')
    .action(async (options) => {
        try {
            await startDevServer({
                appDir: options.appDir,
                port: parseInt(options.port),
                host: options.host
            });
        } catch (error) {
            console.error(chalk.red('❌ Error iniciando servidor de desarrollo:'), error);
            process.exit(1);
        }
    });

program
    .command('build')
    .description('Construir aplicación para producción')
    .option('-m, --mode <mode>', 'Modo de build (ssg o ssr)', 'ssg')
    .option('-a, --app-dir <dir>', 'Directorio de la aplicación', 'app')
    .option('-o, --out-dir <dir>', 'Directorio de salida', 'dist')
    .action(async (options) => {
        try {
            await buildApp({
                appDir: options.appDir,
                outDir: options.outDir,
                mode: options.mode as 'ssg' | 'ssr'
            });
        } catch (error) {
            console.error(chalk.red('❌ Error construyendo aplicación:'), error);
            process.exit(1);
        }
    });

program
    .command('start')
    .description('Iniciar servidor SSR en producción')
    .option('-p, --port <port>', 'Puerto del servidor', '3000')
    .option('-h, --host <host>', 'Host del servidor', 'localhost')
    .option('-a, --app-dir <dir>', 'Directorio de la aplicación', 'app')
    .option('-d, --dist-dir <dir>', 'Directorio de distribución', 'dist')
    .action(async (options) => {
        try {
            await startSSRServer({
                appDir: options.appDir,
                port: parseInt(options.port),
                host: options.host,
                distDir: options.distDir
            });
        } catch (error) {
            console.error(chalk.red('❌ Error iniciando servidor SSR:'), error);
            process.exit(1);
        }
    });

program.parse();
